// extracted by mini-css-extract-plugin
module.exports = {"circle":"LoaderCircle_circle__2LJ6E"};